import type { Cart, CartLine } from '@/clients/storefront/storefrontClient';

export const getFormattedPrice = (
  price: CartLine['merchandise']['price'],
  quantity: number
): string => {
  if (!price?.amount) return '-';

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: price.currencyCode,
  }).format(parseFloat(price.amount) * quantity);
};

export const getFormattedSubtotal = (cart: Cart | null): string => {
  if (!cart) return '-';

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: cart.cost.subtotalAmount.currencyCode,
  }).format(parseFloat(cart.cost.subtotalAmount.amount));
};
